/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable radix */
import React, { useState } from "react";
import { Card, Col, Container, Form, Modal, Pagination, Row, Table } from 'react-bootstrap';
import { fakeRootType } from "../FakeRootType";
import apiCalls from "../PowerShadesAPIFunctions";
import { useUsersList } from "../Store/entities/hooks";
import { toast } from "react-toastify";
import { AdminUserScreenUser } from "../powershadesApiTypeExtensions";
import Button from "../Parts/Button";

type AdminUserScreenProps = {
	ROOT: fakeRootType;
};

type UserFormData = {
	name: string;
	email: string;
	role: string;
};

const AdminUserScreen = ({ ROOT }: AdminUserScreenProps): JSX.Element => {
	const [adminUsers, setAdminUsers] = React.useState<AdminUserScreenUser[]>([]);
	const [loading, setLoading] = React.useState<boolean>(true);
	const [searchTerm, setSearchTerm] = React.useState<string>("");
	const [currentPage, setCurrentPage] = React.useState<number>(1);
	const [usersPerPage] = React.useState<number>(10);
	const [showAddModal, setShowAddModal] = React.useState<boolean>(false);
	const [showEditModal, setShowEditModal] = React.useState<boolean>(false);
	const [showDeleteModal, setShowDeleteModal] = React.useState<boolean>(false);
	const [selectedUser, setSelectedUser] = React.useState<AdminUserScreenUser | null>(null);
	const [formData, setFormData] = React.useState<UserFormData>({
		name: "",
		email: "",
		role: ""
	});

	const users = useUsersList();
	const [isNewUserAdd, setIsNewUserAdd] = React.useState(false);
	const [searchUser, setSearchUser] = useState("");

	// API call placeholders - to be implemented later
	const fetchAdminUsers = async (): Promise<void> => {
		// TODO: Implement API call to fetch admin users
		// Example: const response = await PowerShadesAPI.getAdminUsers();
		// setAdminUsers(response.data);
		apiCalls.getAdminUsers().then((response) => {
			setAdminUsers(response.data.admins);
			setLoading(false);
		}).catch((error) => {
			console.error("Error fetching admin users:", error);
			setLoading(false);
		});
		setLoading(false);
		setAdminUsers([]);
	};

	/*
export type AddUserInput = {
	email: string;
	role_id: number;
	entity_id: number;
	user_name: string;
	entity_name: string;
	password: string;
	confirm_password: string;
	send_email_with_reset: boolean;
};
	*/

	const createAdminUser = async (userData: UserFormData): Promise<void> => {
		apiCalls.createAdminUser({
			user_email: userData.email,
			user_name: userData.name,
			user_role: userData.role
		}).then(() => {
			toast("Admin user created successfully", { type: "success" });
			fetchAdminUsers();
		}).catch((error) => {
			console.error("Error creating admin user:", error);
			toast("Error creating admin user", { type: "error" });
		});
	};

	const updateAdminUser = async (userId: string, userData: UserFormData): Promise<void> => {
		// TODO: Implement API call to update admin user
		// Example: await PowerShadesAPI.updateAdminUser(userId, userData);
		apiCalls.addAdminUserRole({
			user_id: parseInt(userId),
			role_name: userData.role
		}).then(() => {
			fetchAdminUsers();
		}).catch((error) => {
			console.error("Error updating admin user:", error);
		});
	};

	const deleteAdminUser = async (userId: string): Promise<void> => {
		// TODO: Implement API call to delete admin user
		// Example: await PowerShadesAPI.deleteAdminUser(userId);
		apiCalls.deleteUser({
			user_id: parseInt(userId),
			entity_id: 0
		}).then(() => {
			fetchAdminUsers();
		}).catch((error) => {
			console.error("Error deleting admin user:", error);
		});
		// Then refresh the user list
	};

	React.useEffect(() => {
		ROOT.setTitle('Admin Users');
		ROOT.loaded();
		fetchAdminUsers();
	}, []);

	// Filter users based on search term
	const filteredUsers = adminUsers.filter((user) =>
		user.name.toLowerCase().includes(searchTerm.toLowerCase())
        || user.email.toLowerCase().includes(searchTerm.toLowerCase())
        || user.role.toLowerCase().includes(searchTerm.toLowerCase()));

	// Calculate pagination
	const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
	const startIndex = (currentPage - 1) * usersPerPage;
	const endIndex = startIndex + usersPerPage;
	const currentUsers = filteredUsers.slice(startIndex, endIndex);

	const handleAddUser = () => {
		setFormData({ name: "", email: "", role: "" });
		setShowAddModal(true);
	};

	const handleEditUser = (user: AdminUserScreenUser) => {
		setSelectedUser(user);
		setFormData({
			name: user.name,
			email: user.email,
			role: user.role
		});
		setShowEditModal(true);
	};

	const handleDeleteUser = (user: AdminUserScreenUser) => {
		setSelectedUser(user);
		setShowDeleteModal(true);
	};

	// const handleSubmitAdd = async (e: React.FormEvent) => {
	//     e.preventDefault();
	//     await createAdminUser(formData);
	//     setShowAddModal(false);
	//     setFormData({ name: "", email: "", role: "" });
	// };

	const handleSubmitEdit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (selectedUser) {
			await updateAdminUser(selectedUser.id, formData);
		}
		setShowEditModal(false);
		setSelectedUser(null);
		setFormData({ name: "", email: "", role: "" });
	};

	const handleConfirmDelete = async () => {
		if (selectedUser) {
			await deleteAdminUser(selectedUser.id);
		}
		setShowDeleteModal(false);
		setSelectedUser(null);
	};

	const handlePageChange = (page: number) => {
		setCurrentPage(page);
	};

	const roles = [
		{
			value: 'powershades_admin', label: 'PSAdmin'
		},
		{
			value: 'ps_sales_admin', label: 'Sales Admin'
		},
		{
			value: 'ps_mfg_admin', label: 'Manufacturing Admin'
		},
		{
			value: 'read_only_powershades_admin', label: 'Read Only Admin'
		}
	];

	return (
		<Container>
			<Card body className="entity-card">
				<Row className="align-items-center mb-3">
					<Col>
						<h1>Admin Users</h1>
					</Col>
					<Col xs="auto">
						<Button onClick={handleAddUser}>Add User</Button>
					</Col>
				</Row>

				<Row className="mb-3">
					<Col>
						<Form.Control
							type="text"
							placeholder="Search users by name, email, or role..."
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</Col>
				</Row>

				{loading ? (
					<Row>
						<Col>Loading...</Col>
					</Row>
				) : (
					<>
						<Row>
							<Col>
								<Table responsive hover>
									<thead>
										<tr>
											<th>ID</th>
											<th>Name</th>
											<th>Email</th>
											<th>Role</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{currentUsers.map((user) => (
											<tr key={user.id}>
												<td>{user.id}</td>
												<td>{user.name}</td>
												<td>{user.email}</td>
												<td>{user.role}</td>
												<td>
													<Button
														color="green"
														size="sm"
														className="me-2"
														onClick={() => handleEditUser(user)}
													>
														Edit
													</Button>
													<Button
														color="danger"
														size="sm"
														onClick={() => handleDeleteUser(user)}
													>
														Delete
													</Button>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							</Col>
						</Row>

						{totalPages > 1 && (
							<Row className="justify-content-center">
								<Col xs="auto">
									<Pagination>
										<Pagination.Prev
											disabled={currentPage === 1}
											onClick={() => handlePageChange(currentPage - 1)}
										/>
										{Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
											<Pagination.Item
												key={page}
												active={page === currentPage}
												onClick={() => handlePageChange(page)}
											>
												{page}
											</Pagination.Item>
										))}
										<Pagination.Next
											disabled={currentPage === totalPages}
											onClick={() => handlePageChange(currentPage + 1)}
										/>
									</Pagination>
								</Col>
							</Row>
						)}
					</>
				)}
			</Card>

			{/* Add User Modal */}
			<Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Add New User</Modal.Title>
				</Modal.Header>
				<Form
					onSubmit={async (e) => {
						e.preventDefault();
						if (isNewUserAdd) {
							await createAdminUser(formData);
						} else if (formData.name) {
							const selected = Object.values(users).find((u) => String(u.id) === formData.name);
							if (selected) {
								await updateAdminUser(String(selected.id), {
									name: selected.name,
									email: selected.email,
									role: formData.role
								});
							}
						}
						setShowAddModal(false);
						setFormData({ name: "", email: "", role: "" });
					}}
				>
					<Modal.Body>
						<Row className="mb-3">
							<Col>
								<Form.Check
									inline
									type="radio"
									name="addUserMode"
									id="addUserMode-new"
									label="Add New User"
									checked={isNewUserAdd}
									onChange={() => setIsNewUserAdd(true)}
								/>
								<Form.Check
									inline
									type="radio"
									name="addUserMode"
									id="addUserMode-promote"
									label="Promote Existing User"
									checked={!isNewUserAdd}
									onChange={() => setIsNewUserAdd(false)}
								/>
							</Col>
						</Row>

						{isNewUserAdd ? (
							<>
								<Form.Group className="mb-3" controlId="newUserName">
									<Form.Label>Name</Form.Label>
									<Form.Control
										type="text"
										value={formData.name}
										onChange={(e) => setFormData({ ...formData, name: e.target.value })}
										required
									/>
								</Form.Group>
								<Form.Group className="mb-3" controlId="newUserEmail">
									<Form.Label>Email</Form.Label>
									<Form.Control
										type="email"
										value={formData.email}
										onChange={(e) => setFormData({ ...formData, email: e.target.value })}
										required
									/>
								</Form.Group>
							</>
						) : (
							<>
								<Form.Group className="mb-2" controlId="promoteSearch">
									<Form.Label>Search and Select User to Promote</Form.Label>
									<Form.Control
										type="text"
										value={searchUser}
										onChange={(e) => setSearchUser(e.target.value)}
										placeholder="Search users by name or email..."
									/>
								</Form.Group>
								<Form.Group className="mb-3" controlId="promoteSelect">
									<Form.Select
										value={formData.name}
										onChange={(e) => setFormData({ ...formData, name: e.target.value })}
										required
									>
										<option value="">Select User</option>
										{Object.values(users)
											.filter((u) =>
												!adminUsers.some((a) => String(a.id) === String(u.id))
												&& (u.name.toLowerCase().includes(searchUser.toLowerCase())
													|| u.email.toLowerCase().includes(searchUser.toLowerCase())))
											.map((u) => (
												<option key={u.id} value={u.id}>
													{`${u.name} (${u.email})`}
												</option>
											))}
									</Form.Select>
								</Form.Group>
							</>
						)}

						<Form.Group className="mb-1" controlId="userRole">
							<Form.Label>Role</Form.Label>
							<Form.Select
								value={formData.role}
								onChange={(e) => setFormData({ ...formData, role: e.target.value })}
								required
							>
								<option value="">Select Role</option>
								{roles.map((role) => (
									<option key={role.value} value={role.value}>{role.label}</option>
								))}
							</Form.Select>
						</Form.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button color="gray" onClick={() => setShowAddModal(false)}>Cancel</Button>
						<Button type="submit">{isNewUserAdd ? 'Add User' : 'Promote User'}</Button>
					</Modal.Footer>
				</Form>
			</Modal>

			{/* Edit User Modal */}
			<Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Edit User</Modal.Title>
				</Modal.Header>
				<Form onSubmit={handleSubmitEdit}>
					<Modal.Body>
						<Form.Group className="mb-3" controlId="editUserName">
							<Form.Label>Name</Form.Label>
							<Form.Control
								type="text"
								value={formData.name}
								onChange={(e) => setFormData({ ...formData, name: e.target.value })}
								required
								disabled
							/>
						</Form.Group>
						<Form.Group className="mb-3" controlId="editUserEmail">
							<Form.Label>Email</Form.Label>
							<Form.Control
								type="email"
								value={formData.email}
								onChange={(e) => setFormData({ ...formData, email: e.target.value })}
								required
								disabled
							/>
						</Form.Group>
						<Form.Group className="mb-1" controlId="editUserRole">
							<Form.Label>Role</Form.Label>
							<Form.Select
								value={formData.role}
								onChange={(e) => setFormData({ ...formData, role: e.target.value })}
								required
							>
								<option value="">Select Role</option>
								{roles.map((role) => (
									<option key={role.value} value={role.value}>{role.label}</option>
								))}
							</Form.Select>
						</Form.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button color="gray" onClick={() => setShowEditModal(false)}>Cancel</Button>
						<Button type="submit" color="green">Update User</Button>
					</Modal.Footer>
				</Form>
			</Modal>

			{/* Delete Confirmation Modal */}
			<Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Confirm Delete</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{selectedUser && (
						<p>
							Are you sure you want to delete user &quot;
							{selectedUser.name}
							&quot;? This action cannot be undone.
						</p>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button color="gray" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
					<Button color="red" onClick={handleConfirmDelete}>Delete User</Button>
				</Modal.Footer>
			</Modal>
		</Container>
	);
};

export default AdminUserScreen;
